import { render, staticRenderFns } from "./RateEdit.vue?vue&type=template&id=696437fe&scoped=true&"
import script from "./RateEdit.vue?vue&type=script&lang=js&"
export * from "./RateEdit.vue?vue&type=script&lang=js&"
import style0 from "./RateEdit.vue?vue&type=style&index=0&id=696437fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696437fe",
  null
  
)

export default component.exports